module.exports = __webpack_public_path__ + "static/media/indicatorFin.ab18f594.mp4";